import React from 'react'
import Image from 'next/image'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import { convertToSlug } from '@utils/IdGenerator'
import styles from './trustMarkers.module.scss'

const TrustMarkers = ({ data }) => {
  const trustMarkersData = data?.data?.attributes
  const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

  const getModifiedHtml = (htmlContent?: string) => {
    if (!htmlContent) return ''
    const $ = cheerio?.load(htmlContent, null, false)

    $('p').each((_i, el) => {
      if ($(el).html()?.trim() === '&nbsp;') $(el).remove()
    })

    $('a').each((_i, el) => {
      $(el).attr('target', '_blank')
    })

    return $.html()
  }

  const extractH2Text = (html?: string) => {
    if (!html) return null
    const match = html.match(/<h2[^>]*>(.*?)<\/h2>/i)
    return match ? match[1] : null
  }

  const idContent = trustMarkersData?.headerTabName || extractH2Text(trustMarkersData?.sectionHeading)

  return (
    <ErrorBoundary data={data}>
      <section className={`${styles.trustMarkersRootContainer} white skip-child`} id={convertToSlug(idContent)}>
        {trustMarkersData?.sectionHeading && (
          <div
            className={styles.sectionHeading}
            dangerouslySetInnerHTML={{
              __html: getModifiedHtml(trustMarkersData.sectionHeading),
            }}
          />
        )}

        <div className={styles.cardsContainer}>
          {trustMarkersData?.markerCards?.map((card, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.cardText}>
                {card?.markerValue && <div className={styles.primaryText}>{card?.markerValue}</div>}
                {card?.markerHeading && <div className={styles.secondaryText}>{card?.markerHeading}</div>}
                {card?.markerSubHead && <div className={styles.tertiaryText}>{card?.markerSubHead}</div>}
              </div>

              {card?.markerImage?.data?.attributes?.url && (
                <div className={styles.cardImage}>
                  <Image
                    className={styles.image}
                    src={card.markerImage.data.attributes.url}
                    alt={card?.markerHeading || 'trust-marker'}
                    height={224}
                    width={287}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </ErrorBoundary>
  )
}

export default TrustMarkers
